export default __webpack_public_path__ + "resources/icons/n430-78db.png";